import { Article } from '@/models/article/Article';
import modelService from '@/services/ModelService';

export class Draft extends Article {
  static fromJson(jsonData: unknown) {
    return modelService.create(Draft, jsonData);
  }
}
